<ng-template #updateMessage let-toast
  >A new version of For The Record is available,
  <a href="javascript:void(0)" (click)="restartApp(toast)">restart the app</a> to get the latest features.</ng-template
>
